import * as React from 'react';
import { useHistory } from 'react-router-dom';

import { Breadcrumbs } from '@mui/material';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';

import {
  BreadcrumbContainer,
  BreadcrumbLinkComponent,
} from 'app/components/StyledComponents';

type BreadcrumbsComponentProps = {
  breadcrumbsList: Array<{
    label: string;
    link?: string;
    isActive?: boolean;
  }>;
  state?: Record<string, unknown>;
};

export const BreadcrumbsComponent = ({
  breadcrumbsList,
  state,
}: BreadcrumbsComponentProps) => {
  const history = useHistory();

  const handleClick = (
    breadcrumb: { label: string; link?: string; isActive?: boolean },
    breadcrumbIndex: number,
  ) => {
    try {
      if (breadcrumb.isActive) {
        return;
      }
      if (!breadcrumb.link || typeof breadcrumb.link !== 'string') return;
      const list = breadcrumbsList.filter(
        (item, index) => index <= breadcrumbIndex,
      );
      list[list.length - 1] = { ...list[list.length - 1], isActive: true };
      history.push(breadcrumb.link, state ?? { breadcrumbsList: list });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <BreadcrumbContainer>
      <Breadcrumbs
        aria-label="breadcrumb"
        separator={<NavigateNextIcon fontSize="small" />}
      >
        {breadcrumbsList?.map((item, index) => (
          <BreadcrumbLinkComponent
            key={`${item.label}-${index}`}
            underline={item.isActive ? 'none' : 'always'}
            color={item.isActive ? 'text.primary' : 'inherit'}
            onClick={() => handleClick(item, index)}
            sx={{ cursor: item.isActive ? '' : 'pointer' }}
          >
            {item.label}
          </BreadcrumbLinkComponent>
        ))}
      </Breadcrumbs>
    </BreadcrumbContainer>
  );
};
